<mat-drawer-container class="drawer-container cf-flex-row">
  <mat-drawer mode="side" position="end" opened class="flex-350">
    <mat-toolbar>Scene</mat-toolbar>
    <app-object3d-tree [v3dObject]="root" [(selectedV3dObject)]="selectedV3dObject"></app-object3d-tree>
    <mat-divider></mat-divider>
    <mat-toolbar *ngIf="selectedV3dObject">Editor</mat-toolbar>
    <app-object3d-editor
      *ngIf="selectedV3dObject"
      [v3dObject]="selectedV3dObject"
      (componentChange)="componentChange()"
    ></app-object3d-editor>
  </mat-drawer>
  <mat-drawer-content class="cf-flex-column">
    <app-menu
      [selectedV3dObject]="selectedV3dObject"
      (addV3dObject)="addObject3d()"
      (deleteV3dObject)="removeSelectedV3dObject()"
      (viewChange)="viewChange($event)"
      (fitChange)="fitChange($event)"
      (orthographicView)="orthographicChange($event)"
      (export)="export($event)"
      (importV3dObject)="importObject3d($event)"
      (refresh)="apiService.clearCache(); refreshV3dObject()"
      (preferences)="openPreferences()"
      (about)="openAbout()"
    ></app-menu>

    <v3d-orthographic-view
      #orthographicView
      *ngIf="isOrthographic"
      [v3dObject]="root"
      [viewerOptions]="navigation"
      [sceneManager]="orthographicSceneManager"
      (error)="on3DViewError($event)"
      (v3dObjectLoadStatus)="onObject3DLoadStatus($event)"
    ></v3d-orthographic-view>
    <v3d-perspective-view
      #perspectiveView
      *ngIf="!isOrthographic"
      [v3dObject]="root"
      [viewerOptions]="navigation"
      [sceneManager]="perspectiveSceneManager"
      (error)="on3DViewError($event)"
      (v3dObjectLoadStatus)="onObject3DLoadStatus($event)"
    ></v3d-perspective-view>
  </mat-drawer-content>
</mat-drawer-container>
